/*
    Managing and caching EFID related information
*/
define('shared/remote/efid/cache',[
    'shared/lib/store',
    'shared/lib/RSVP',
    'shared/my/efid'
],
function  (store, RSVP, efid) {
    'use strict';

    var KEY_STORE = 'shared/remote/efid/cache';
    var cache = store.get(KEY_STORE) || {};

    var cmusManager = {
        get: function(key) {
            return new RSVP.Promise(function(resolve){
                resolve(cache[key]);
            });
        },
        set: function(key, value) {
            var me = this;
            return efid.get()
                .then(function(efid){
                    return new RSVP.Promise(function(resolve, reject){
                        if ( value == null ) {
                            value = key;
                            key = efid;
                        }

                        if ( key == null ) {
                            reject('EFID is not found');
                        }

                        resolve();
                    });
                })
                .then(function () {
                    return me.clear();
                })
                .then(function(){
                    cache[key] = value;
                    store.set(KEY_STORE, cache);
                });
        },
        del: function(key) {
            return new RSVP.Promise(function(resolve){
                delete cache[key];

                store.set(KEY_STORE, cache);  
                resolve();
            });
        },
        clear: function () {
            return new RSVP.Promise(function(resolve){
                for(var key in cache){
                    if(!cache.hasOwnProperty(key)){
                        continue;
                    }

                    delete cache[key];
                }

                store.set(KEY_STORE, cache);  
                resolve();
            });
        }
    };

    return cmusManager;
});
